import animalCareGuide from "./Guides/AnimalCareGuide";
import GuideRenderer from "../../components/wikiComponents/GuideRenderer";

const AnimalCareGuide = () => {
  return <GuideRenderer url="animalcare" guideData={animalCareGuide} />;
};

export default AnimalCareGuide;
